import script from "./Documentation.vue?vue&type=script&setup=true&lang=js"
export * from "./Documentation.vue?vue&type=script&setup=true&lang=js"

import "./Documentation.vue?vue&type=style&index=0&id=78a3bb96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a3bb96"]])

export default __exports__